import { Hero } from "@/components/home/Hero";
import { Banner } from "@/components/home/Banner";
import { Announcements } from "@/components/home/Announcements";
import { Choice } from "@/components/home/Choice";
import { Featured } from "@/components/home/Featured";
import { Schedule, GiveCta } from "@/components/home/Sections";
import { Marquee } from "@/components/Marquee";
import { CustomBlock } from "@/components/PageLayout";
import { useSite } from "@/context/SiteContext";
import { homeOrder } from "@/lib/design";
import { layoutOf } from "@/lib/blocks";

const SECTIONS = { banner: Banner, hero: Hero, announcements: Announcements, marquee: Marquee, choice: Choice, featured: Featured, schedule: Schedule, give: GiveCta };

export default function Home() {
  const { on, settings, ready } = useSite();
  const visible = (k) => on(k) && (k !== "featured" || on("sermons")) && (k !== "give" || (on("donate") && settings?.donate_enabled));
  const list = layoutOf("home", settings?.layouts?.home, homeOrder(settings?.home_order));
  // Wait for the saved layout so the default order never flashes before it.
  if (!ready) return <main data-testid="home-page" className="min-h-screen" />;
  return (
    <main data-testid="home-page">
      {list.map((b) => {
        if (b.type !== "section") return b.hidden ? null : <CustomBlock key={b.id} page="home" b={b} />;
        const Section = SECTIONS[b.key];
        if (!Section || !visible(b.key)) return null;
        return <div key={b.key} data-ve-section={b.key} data-testid={`home-section-${b.key}`}><Section /></div>;
      })}
    </main>
  );
}
